import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Users'

export const UsersEP : EndPointConfig[] =[
    new EndPointConfig()
        .setMethod('POST')
        .setController(controller) 
        .setActionName("DoLogin"),
    new EndPointConfig()
        .setMethod('POST')
        .setController(controller) 
        .setActionName("DoLoginAsUser"),
    new EndPointConfig()
        .setMethod('POST')
        .setController(controller) 
        .setActionName("AddCreditCard"),
    new EndPointConfig()
        .setMethod('POST')
        .setController(controller) 
        .setActionName("AddSEPA"),
    new EndPointConfig()
        .setMethod('POST')
        .setController(controller) 
        .setActionName("GetMyCreditCardData"),
    new EndPointConfig()
        .setMethod('POST')
        .setController(controller) 
        .setActionName("GetMySEPAData"),
    new EndPointConfig()
        .setMethod('POST')
        .setController(controller) 
        .setActionName("SetAsDefaultPaymentMethod"),
    new EndPointConfig()
        .setMethod('DELETE')
        .setController(controller)        
        .setActionName("DoLogout"),
    new EndPointConfig()
        .setMethod('POST')
        .setController(controller)        
        .setActionName("Register"),
    new EndPointConfig()
        .setMethod('POST')
        .setController(controller)        
        .setActionName("ChangeMyPasswordStep1"),
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)        
        .setActionName("ChangeMyPasswordStep2")
        .setPattern("{hash}"),    
    new EndPointConfig()
        .setMethod('POST')
        .setController(controller)        
        .setActionName("ResendValidateAccountEmail"),
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)        
        .setActionName("ValidateAccount")
        .setPattern("{hash}"),
    new EndPointConfig()
        .setMethod('PUT')
        .setController(controller)        
        .setActionName("UpdateUserProfile"),
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)
        .setActionName('SendContactEmail')

]